module.exports = __webpack_public_path__ + "static/media/red-template-big.e03c7209.png";